module.exports = __webpack_public_path__ + "img/44.87ee7df8.jpg";